"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const ActionTypes = require("../../actionTypes/project/copy");
//#region INITIAL STATE
exports.initialState = {
    isOpen: false,
    mode: 'COPY',
    companiesStatus: 'STANDBY',
    companies: [],
    templatesStatus: 'STANDBY',
    templates: [],
    data: {
        selectedCompany: undefined,
        copyFrom: undefined,
        projectName: '',
        projectDescription: '',
        folderStructure: false,
        files: false,
        users: false,
        userGroups: false
    },
    copied: undefined,
    status: 'INITIAL',
    errors: {}
};
//#endregion
//#region LENS
const isOpenLens = monocle.Lens.fromProp('isOpen');
const modeLens = monocle.Lens.fromProp('mode');
const companiesStatusLens = monocle.Lens.fromProp('companiesStatus');
const companiesLens = monocle.Lens.fromProp('companies');
const templatesStatusLens = monocle.Lens.fromProp('templatesStatus');
const templatesLens = monocle.Lens.fromProp('templates');
const dataLens = monocle.Lens.fromProp('data');
const statusLens = monocle.Lens.fromProp('status');
const updateFieldLens = (key) => monocle.Lens.fromProp(key);
const valuesErrorsLens = monocle.Lens.fromProp('errors');
const copiedLens = monocle.Lens.fromProp('copied');
//#endregion
//#region METHODS
exports.methods = {};
exports.methods[ActionTypes.TOGGLE_COPY_MODAL] = (state, action) => {
    if (isOpenLens.get(state)) {
        return Object.assign({}, exports.initialState);
    }
    return fp.function.compose(dataLens.modify(updateFieldLens('copyFrom').set(action.payload.project)), modeLens.set(action.payload.mode || 'COPY'), isOpenLens.modify((isOpen) => !isOpen))(state);
};
exports.methods[ActionTypes.SEARCH_COMPANY_REQUEST] = (state, action) => companiesStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.SEARCH_COMPANY_SUCCESS] = (state, action) => fp.function.compose(companiesStatusLens.set('FETCHED'), companiesLens.set(action.payload))(state);
exports.methods[ActionTypes.SEARCH_COMPANY_FAILED] = (state, action) => companiesStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.FETCH_TEMPLATES_REQUEST] = (state, action) => templatesStatusLens.set('FETCHING')(state);
exports.methods[ActionTypes.FETCH_TEMPLATES_SUCCESS] = (state, action) => fp.function.compose(templatesStatusLens.set('FETCHED'), templatesLens.set(action.payload))(state);
exports.methods[ActionTypes.FETCH_TEMPLATES_FAILED] = (state, action) => templatesStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.UPDATE_FIELD] = (state, action) => {
    let copyState = Object.assign({}, state);
    if (action.payload.key === 'folderStructure' &&
        !action.payload.value &&
        dataLens.get(state).files) {
        copyState = dataLens.modify(updateFieldLens('files').set(false))(copyState);
    }
    if (action.payload.key === 'userGroups' &&
        !action.payload.value &&
        dataLens.get(state).users) {
        copyState = dataLens.modify(updateFieldLens('users').set(false))(copyState);
    }
    return fp.function.compose(dataLens.modify(updateFieldLens(action.payload.key).set(action.payload.value)), valuesErrorsLens.modify((err) => {
        delete err[action.payload.key];
        return err;
    }))(copyState);
};
exports.methods[ActionTypes.VALIDATE_STEP_FAILURE] = (state, action) => fp.function.compose(valuesErrorsLens.set(action.payload.errors.reduce((rv, x) => {
    ;
    (rv[x.key] = rv[x.key] || []).push(x.value);
    return rv;
}, {})), statusLens.set('FAILED'))(state);
exports.methods[ActionTypes.COPY_PROJECT_REQUEST] = (state) => statusLens.set('COPYING')(state);
exports.methods[ActionTypes.COPY_PROJECT_SUCCESS] = (state, action) => fp.function.compose(copiedLens.set(action.payload), statusLens.set('COPIED'))(state);
exports.methods[ActionTypes.COPY_PROJECT_FAILURE] = (state) => statusLens.set('FAILED')(state);
//#endregion
const reducer = (state, action) => exports.methods[action.type](state, action);
exports.reducer = reducer;
//# sourceMappingURL=copy.js.map